import { flex, flexColumn } from 'hfty-styles/src/mixins'
import { black, white, primary } from 'hfty-styles/src/colors'

const HEADER_HEIGHT = '50px'
const CONTENT_TEXT = {
  display: 'block',
  paddingBottom: '17px',
  fontSize: '18px',
  lineHeight: 1.45,
}

export const styles = {
  header: {
    ...flexColumn('flex-start', 'flex-start'),
    width: '100%',
    marginBottom: '25px',
  },
  headerTitle: {
    ...flex('flex-start', 'center'),
    height: HEADER_HEIGHT,
    marginBottom: '25px',
    fontSize: '24px',
    borderBottom: `3px solid ${black()}`,
  },

  headerContent: {
    maxWidth: '75%',
  },
  headerContentSentence: {
    ...CONTENT_TEXT,
  },

  packageDetailsWrapper: {
    maxWidth: '700px',
    margin: '10px 0 25px',
    padding: '15px 25px 15px 45px',
    border: `1px solid ${primary()}`,
  },
  packageDetailsTitle: {
    display: 'block',
    fontSize: '19px',
    paddingBottom: '15px',
    color: primary(),
  },

  packageDetailsLists: {
    ...flex('space-between'),
  },
  listItem: {
    paddingBottom: '7px',
    listStyle: 'disc',
  },
  detailsHide: {
    display: 'none',
  },

  tableDescription: {
    ...CONTENT_TEXT,
    color: '#5975B9',
  },

  footer: {
    ...flexColumn('flex-start', 'flex-end'),
    width: '75%',
    marginTop: '50px',
    paddingTop: '15px',
    borderTop: `3px solid ${black()}`,
  },

  submitButton: {
    width: '160px',
    height: '45px',
    fontSize: '17px',
    color: white(),
    backgroundColor: primary(),
    border: `1px solid ${primary()}`,
    cursor: 'pointer',
  },

  footerDescription: {
    display: 'block',
    marginBottom: '15px',
    fontSize: '18px',
  },

  minimumCharge: {
    ...flex('flex-start'),
    width: '100%',
    fontSize: '18px',
    color: '#5975B9',
  },
}
